import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { MarketFormMode, MarketFormValues } from './MarketForm.interface'

const DESCRIPTION_READ_ONLY_HINT =
  "A market's description cannot be changed yet — the admin API only accepts a new name."

interface Props {
  mode: MarketFormMode
}

const MarketFormContentComponent = ({ mode }: Props) => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<MarketFormValues>
        name="title"
        label="Name"
        placeholder="e.g. Dallas-Fort Worth"
      />
      {mode === 'create' ? (
        <FormikTextField<MarketFormValues>
          name="description"
          label="Description"
          placeholder="Optional"
        />
      ) : (
        <div>
          <FormikTextField<MarketFormValues>
            name="description"
            label="Description"
            InputProps={{ readOnly: true }}
            placeholder="—"
          />
          <Typography variant="body2" css={tw`mt-1 text-shades-500`}>
            {DESCRIPTION_READ_ONLY_HINT}
          </Typography>
        </div>
      )}
    </div>
  )
}

export const MarketFormContent = memo(MarketFormContentComponent)
